import React, { useEffect, useState } from 'react';
import { Calendar, Clock, Check, AlertTriangle, CheckCircle, BookOpenIcon, PenLineIcon, VideoIcon, FileTextIcon } from 'lucide-react';
import { MOCK_PROGRAM_DATA, ScheduleItem, getActivityLabel, getSubjectGradient } from '../utils/programData';
export function VeliDersProgrami() {
  const [viewMode, setViewMode] = useState<'daily' | 'weekly'>('daily');
  const [selectedDay, setSelectedDay] = useState(new Date().toLocaleString('tr-TR', {
    weekday: 'long'
  }));
  const [scheduleItems, setScheduleItems] = useState<Record<string, ScheduleItem[]>>({});
  // Use the shared mock data
  useEffect(() => {
    setScheduleItems(MOCK_PROGRAM_DATA);
  }, []);
  const getActivityIcon = (type: string) => {
    switch (type) {
      case 'study':
        return BookOpenIcon;
      case 'practice':
        return PenLineIcon;
      case 'exam':
        return FileTextIcon;
      case 'video':
        return VideoIcon;
      case 'homework':
        return FileTextIcon;
      default:
        return Clock;
    }
  };
  const weekDays = ['Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi', 'Pazar'];
  const today = new Date().toLocaleString('tr-TR', {
    weekday: 'long'
  });
  const dayItems = scheduleItems[selectedDay] || [];
  const completedCount = dayItems.filter(item => item.completed).length;
  const totalCount = dayItems.length;
  const completionRate = totalCount > 0 ? Math.round(completedCount / totalCount * 100) : 0;
  const uncompletedCount = totalCount - completedCount;
  return <div className="space-y-6" data-id="element-654">
      <h1 className="text-2xl font-bold" data-id="element-655">Ders Programı</h1>
      {/* Görünüm seçimi - ŞİK TASARIM */}
      <div className="flex justify-center mb-6" data-id="element-656">
        <div className="inline-flex bg-black/30 rounded-lg p-1 backdrop-blur-sm" data-id="element-657">
          <button onClick={() => setViewMode('daily')} className={`px-6 py-3 rounded-lg transition-all duration-300 ${viewMode === 'daily' ? 'bg-gradient-to-r from-blue-600 to-indigo-600 text-white shadow-lg shadow-blue-500/25' : 'text-gray-300 hover:bg-white/10 hover:text-white'}`} data-id="element-658">
            Günlük Görünüm
          </button>
          <button onClick={() => setViewMode('weekly')} className={`px-6 py-3 rounded-lg transition-all duration-300 ${viewMode === 'weekly' ? 'bg-gradient-to-r from-blue-600 to-indigo-600 text-white shadow-lg shadow-blue-500/25' : 'text-gray-300 hover:bg-white/10 hover:text-white'}`} data-id="element-659">
            Haftalık Görünüm
          </button>
        </div>
      </div>

      {viewMode === 'daily' && <div className="space-y-6" data-id="element-660">
          {/* ŞİK GÜN SEÇİCİ */}
          <div className="flex justify-center mb-6" data-id="element-661">
            <div className="flex gap-1 bg-black/30 rounded-xl p-2 backdrop-blur-sm" data-id="element-662">
              {weekDays.map(day => <button key={day} onClick={() => setSelectedDay(day)} className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 ${selectedDay === day ? 'bg-gradient-to-r from-blue-600 to-indigo-600 text-white shadow-lg shadow-blue-500/25' : day === today ? 'bg-blue-900/30 text-blue-300 hover:bg-blue-800/40' : 'text-gray-400 hover:bg-white/10 hover:text-white'}`} data-id="element-663">
                  {day.substring(0, 3)}
                </button>)}
            </div>
          </div>
          {/* ŞİK BAŞLIK */}
          <div className="flex items-center justify-between" data-id="element-664">
            <div className="flex items-center gap-3" data-id="element-665">
              <Calendar className="w-6 h-6 text-blue-400" data-id="element-666" />
              <h2 className="text-2xl font-bold" data-id="element-667">
                {selectedDay === today ? 'Bugün' : selectedDay}
              </h2>
              {selectedDay === today && <span className="px-3 py-1 bg-blue-500/20 text-blue-400 text-sm rounded-full border border-blue-500/30" data-id="element-668">
                  Güncel
                </span>}
            </div>
            {totalCount > 0 && <div className="text-right" data-id="element-669">
                <div className="text-sm text-gray-400" data-id="element-670">Tamamlanma</div>
                <div className={`text-lg font-bold ${completionRate >= 80 ? 'text-green-400' : completionRate >= 50 ? 'text-yellow-400' : 'text-red-400'}`} data-id="element-671">
                  %{completionRate}
                </div>
              </div>}
          </div>

          {/* GÜNLÜK UYARI - ŞİK TASARIM */}
          {uncompletedCount > 0 && <div className="relative p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-yellow-500 to-orange-500" data-id="element-672">
              <div className="bg-black/90 p-4 rounded-xl" data-id="element-673">
                <div className="flex items-center gap-3" data-id="element-674">
                  <AlertTriangle className="w-5 h-5 text-yellow-400" data-id="element-675" />
                  <span className="text-yellow-300 font-medium" data-id="element-676">
                    {uncompletedCount} etkinlik henüz tamamlanmadı
                  </span>
                </div>
              </div>
            </div>}

          {/* FIX: Split into two different completion rate messages */}
          {completionRate === 100 && totalCount > 0 && <div className="relative p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-green-500 to-emerald-500" data-id="element-677">
              <div className="bg-black/90 p-4 rounded-xl" data-id="element-678">
                <div className="flex items-center gap-3" data-id="element-679">
                  <CheckCircle className="w-5 h-5 text-green-400" data-id="element-680" />
                  <span className="text-green-300 font-medium" data-id="element-681">
                    Mükemmel! Günlük programın tamamı başarıyla tamamlandı! 🎉
                  </span>
                </div>
              </div>
            </div>}

          {completionRate >= 80 && completionRate < 100 && totalCount > 0 && <div className="relative p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-green-500 to-emerald-500" data-id="element-682">
              <div className="bg-black/90 p-4 rounded-xl" data-id="element-683">
                <div className="flex items-center gap-3" data-id="element-684">
                  <CheckCircle className="w-5 h-5 text-green-400" data-id="element-685" />
                  <span className="text-green-300 font-medium" data-id="element-686">
                    Mükemmel! Günlük programın büyük kısmı tamamlandı.
                  </span>
                </div>
              </div>
            </div>}

          {/* ŞİK PROGRAM KARTLARI */}
          <div className="space-y-4" data-id="element-687">
            {dayItems.length > 0 ? dayItems.sort((a, b) => a.startTime.localeCompare(b.startTime)).map(item => {
          const Icon = getActivityIcon(item.activityType);
          const gradientClass = getSubjectGradient(item.subject);
          // Kurum dersi (dolu renkli)
          if (item.isInstitutional) {
            return <div key={item.id} className={`p-5 rounded-xl bg-gradient-to-r ${gradientClass} ${item.completed ? 'opacity-60' : ''} group hover:shadow-[0_0_20px_rgba(255,255,255,0.1)] transition-all duration-300 transform hover:scale-[1.02]`} data-id="element-688">
                        <div className="flex items-center justify-between mb-3" data-id="element-689">
                          <h3 className="text-xl font-bold text-white" data-id="element-690">
                            {item.subject}
                          </h3>
                          <div className="flex items-center gap-3" data-id="element-691">
                            <span className="text-sm text-white/90 bg-black/20 px-3 py-1 rounded-full" data-id="element-692">
                              {item.startTime.substring(0, 5)} -{' '}
                              {item.endTime.substring(0, 5)}
                            </span>
                            {item.completed && <Check className="w-6 h-6 text-white bg-green-500 rounded-full p-1" data-id="element-693" />}
                          </div>
                        </div>
                        <div className="flex items-center gap-2 text-white/90" data-id="element-694">
                          <Icon className="w-5 h-5" data-id="element-695" />
                          <span className="font-medium" data-id="element-696">Kurum Dersi</span>
                        </div>
                        {item.notes && <div className="mt-3 text-white/80 bg-black/20 p-3 rounded-lg" data-id="element-697">
                            {item.notes}
                          </div>}
                        {/* Parlama efekti */}
                        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-[rgba(255,255,255,0.15)] to-transparent group-hover:translate-x-full -skew-x-12 transition-transform duration-1000 ease-out" data-id="element-698" />
                      </div>;
          }
          // Kişisel çalışma (kenarlık renkli)
          return <div key={item.id} className={`relative p-[1px] rounded-xl overflow-hidden bg-gradient-to-r ${gradientClass} ${item.completed ? 'opacity-60' : ''} group hover:shadow-[0_0_20px_rgba(255,255,255,0.1)] transition-all duration-300 transform hover:scale-[1.02]`} data-id="element-699">
                      <div className="bg-black/90 p-5 rounded-xl" data-id="element-700">
                        <div className="flex items-center mb-4" data-id="element-701">
                          <div className={`w-7 h-7 rounded-full flex items-center justify-center mr-4 ${item.completed ? 'bg-green-500 text-white' : 'bg-white/10'}`} data-id="element-702">
                            {item.completed && <Check className="w-4 h-4" data-id="element-703" />}
                          </div>
                          <div data-id="element-704">
                            <h3 className={`text-xl font-bold ${item.completed ? 'line-through text-gray-400' : 'text-white'}`} data-id="element-705">
                              {item.subject}
                            </h3>
                          </div>
                        </div>
                        <div className="space-y-3" data-id="element-706">
                          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2" data-id="element-707">
                            <span className="text-gray-300 flex items-center gap-2" data-id="element-708">
                              <Icon className="w-5 h-5 text-blue-400" data-id="element-709" />
                              <span className="font-medium" data-id="element-710">
                                {getActivityLabel(item.activityType)}
                              </span>
                            </span>
                            <span className="text-sm text-gray-300 bg-white/5 px-3 py-1 rounded-full" data-id="element-711">
                              {item.startTime} - {item.endTime}
                            </span>
                          </div>
                          {item.notes && <div className="text-gray-400 bg-white/5 p-3 rounded-lg" data-id="element-712">
                              <span className="text-blue-400 font-medium" data-id="element-713">
                                Not:{' '}
                              </span>
                              {item.notes}
                            </div>}
                        </div>
                        {/* Parlama efekti */}
                        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-[rgba(255,255,255,0.1)] to-transparent group-hover:translate-x-full -skew-x-12 transition-transform duration-1000 ease-out" data-id="element-714" />
                      </div>
                    </div>;
        }) : <div className="text-center py-12" data-id="element-715">
                <Calendar className="w-16 h-16 text-gray-600 mx-auto mb-4" data-id="element-716" />
                <h3 className="text-xl font-medium text-gray-400 mb-2" data-id="element-717">
                  Bu gün için program boş
                </h3>
                <p className="text-gray-500" data-id="element-718">
                  {selectedDay} günü için henüz aktivite planlanmamış
                </p>
              </div>}
          </div>
        </div>}

      {viewMode === 'weekly' && <div className="text-center py-12" data-id="element-719">
          <Calendar className="w-16 h-16 text-gray-600 mx-auto mb-4" data-id="element-720" />
          <h3 className="text-xl font-medium text-gray-400 mb-2" data-id="element-721">
            Haftalık Görünüm
          </h3>
          <p className="text-gray-500" data-id="element-722">
            Haftalık program görünümü yakında eklenecek
          </p>
        </div>}
    </div>;
}